
const Hero = () => {
    return ( 
        <section id='experience-container'>
            <div className='experiemce-heading'>
                <h1>Work  <span>Experience</span></h1>
                <p>I had amazing working experiences with the following startup companies.</p>
            </div>
          <div className="experience-cont">
          <div className='Card-01'>
            <span>June 2018 - 2019</span>
            <h1>UI/UX Designer</h1>
            <span>AMB-Studios.</span>
            <p>I've been in charge of the User Interaction and User Interface Team,Amazing experience i'll say.</p>
          </div>
          <div className='Card-02'>
            <span>June 2019 - 2021</span>
            <h1>Frontend Web Developer</h1>
            <span>Karakkai Tech.</span>
            <p>At Karakkai Tech, every single day is a good day ): So much Devs ideas and fun.</p>
          </div>
          <div className='Card-03'>
            <span>June 2022 - Date</span>
            <h1>CEO & Web Developer</h1>
            <span>Gowebsite.com.ng.</span>
            <p>Been the Chief Executive Office,I've rocked and rolled with all of my Dev team.</p>
          </div>
        </div>
        </section>
       
     );
}
 
export default Hero;